module.exports = __webpack_public_path__ + "static/media/logo-xcm.7f83189f.svg";